import React, { useState } from "react";

import { Link } from "react-router-dom";
import "./AuthForm.css";

import AuthUser from "../../services/AuthUser";


// Adjust the path as needed

const AuthForm = () => {
  const { http, setToken } = AuthUser();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [emailChecked, setEmailChecked] = React.useState(false);
  const [emailExists, setEmailExists] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  const handleCheckEmail = async () => {
    setError(null);
    if (!email) {
      setError("Email is required.");
      return;
    }

    try {
      const response = await http.post('/authcheck', { email }, {
        headers: { 'Content-Type': 'application/json' },
      });

      // If we get here, status is 200
      if (response.data.email_exists) {
        setEmailExists(true);
        setEmailChecked(true);
      } else {
        // Should not happen if backend is correct, but safe fallback
        setError("Email does not exist.");
      }
    } catch (err) {
      // If 404 or any other error
      if (err.response && err.response.status === 404) {
        setError(err.response.data.message || "Account does not exist.");
        setEmailExists(false);
        setEmailChecked(false);
      } else {
        setError(err.message || "Something went wrong");
      }
    }
  };


  // Handle form submission
  const submitForm = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const endpoint = "/login";
      const data = { email, password };

      // Make sure Axios sends JSON
      const response = await http.post(endpoint, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (isLogin) {
        setToken(response.data.user, response.data.access_token);
      }
    } catch (err) {


      setError(err.response.data.message || "Incorrect password!");
    }
    finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await http.post('/forgot-password', {
        email: email,
      });

      alert(response.data.message); // Or show it in UI
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };


const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  input: {
    flex: "1",
    padding: windowWidth < 480 ? "8px 10px" : "10px 14px",
    fontSize: windowWidth < 480 ? "14px" : windowWidth < 768 ? "15px" : "16px",
    borderRadius: "4px 0 0 4px",
    border: "1px solid #ccc",
    outline: "none",
    boxSizing: "border-box",
  },
  button: {
    padding: windowWidth < 480 ? "8px 10px" : "10px 14px",
    fontSize: windowWidth < 480 ? "14px" : windowWidth < 768 ? "15px" : "16px",
    cursor: "pointer",
    border: "1px solid #007bff",
    borderLeft: "none",
    backgroundColor: "#007bff",
    color: "white",
    borderRadius: "0 4px 4px 0",
    userSelect: "none",
  },
};



  return (
    <div className="bg-color">
      <div className="containerr h-100  d-flex justify-content-center align-items-center">
        <div className="containerr d-flex justify-content-center align-items-center">
          <div className="col-lg-7 h100 d-flex flex-column justify-content-center align-items-center bg-w">
            <div className="rounded text-black">
              <div className="user-log-img">
                <Link to="/">
                  <img src="assets/img/logo/header-logo10a.svg" alt="" />
                </Link>
                <img className="user-img" src="assets/img/images/Annual-Compliance-LLP.png" alt="" />
              </div>
              <div className="txtt text-center">
                <h4 className="user-login-txt">"Secure your legal needs with ease. Log in and take the next step towards hassle-free legal solutions."</h4>
              </div>
            </div>

          </div>
          <div className="col-lg-5 h100  d-flex flex-column  justify-content-center align-items-center bg-g">
            <div className=" card form-sec rounded-3 color text-black">
              <div className="card-body  mx-2">
                {!showForgotPasswordForm && (<form onSubmit={submitForm}>
                  <h4 className="text-center mb-4">Login</h4>





                  {/* Show email input only if email not checked */}
                  {!emailChecked && (
                    <div style={styles.container}>
                      <input
                        type="email"
                        id="email"
                        placeholder="Enter email..."
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={styles.input}
                        required
                      />
                      <button type="button" onClick={handleCheckEmail} style={styles.button} aria-label="Next">
                        ➔
                      </button>
                    </div>
                  )}

                  {/* Show password input if email exists */}
                  {emailChecked && emailExists && (
                    <div style={styles.container}>
                      <input
                        type="password"
                        id="password"
                        placeholder="Enter password..."
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={styles.input}
                        required
                      />
                      <button type="submit" style={styles.button}>
                        Login
                      </button>
                    </div>
                  )}

                  {/* Forgot password link */}
                  <Link
                    to="#"
                    onClick={() => setShowForgotPasswordForm(true)}
                    style={{ fontSize: '14px', color: '#007bff', textDecoration: 'none' }}
                  >
                    Forgot Password?
                  </Link>


                  {/* Error messages */}
                  <div className="text-center error-text" style={{ maxWidth: '315px', margin: '1 auto', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                    {error && <p style={{ fontSize: '15px', marginTop: '3px' }}>{error}</p>}
                  </div>


                  {/* <div className="text-center error-text" style={{ maxWidth: '315px', margin: '1 auto', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                    {error?.email && Array.isArray(error.email) && error.email.length > 0 ? (
                      error.email.map((msg, index) => <p key={index}>{msg}</p>)
                    ) : error?.message ? (
                      <p style={{ fontSize: '15px', marginTop: '3px' }}
                      >{error.message}</p>
                    ) : error?.error ? (
                      <p style={{ fontSize: '15px', marginTop: '3px' }}
                      >{error.error}</p>
                    ) : null}
                  </div> */}



                  <div className="text-end  pt-1 mt-2 pb-2">
                    <Link to="/" >Back to Home</Link>
                  </div>
                </form>
                )}

                {showForgotPasswordForm && (
                  <form onSubmit={handleForgotPassword}>
                    <h4 className="text-center mb-4">Reset Password</h4>
                    <div style={styles.container}>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={styles.input}
                        required
                      />
                      <button type="submit" style={styles.button}>
                        Send Link
                      </button>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '8px' }}>
                      <button
                        type="button"
                        onClick={() => setShowForgotPasswordForm(false)}
                        style={{ fontSize: '14px', color: '#007bff', background: 'none', border: 'none' }}
                      >
                        ← Back to Login
                      </button>
                    </div>
                  </form>
                )}


              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};





export default AuthForm;
